import { VStack } from '@chakra-ui/react';
import { BackofficeActivitiesOrderItem } from '@diamond/shared/types';
import { IndeterminateCheckbox } from '@diamond/sol-admin/components';
import { Row } from '@tanstack/react-table';

import { isNewProduct } from '../../../utils/activity-formatters';

interface CheckboxColumnProps {
  info: Row<BackofficeActivitiesOrderItem>;
  selectedData: Row<BackofficeActivitiesOrderItem>[];
  onSelectAll: (
    values: Row<BackofficeActivitiesOrderItem>[],
    isChecked: boolean
  ) => void;
  onSelectOne: (
    value: Row<BackofficeActivitiesOrderItem>,
    isChecked: boolean
  ) => void;
  isDisabled: boolean;
}

export function CheckboxColumn({
  info,
  selectedData,
  onSelectAll,
  onSelectOne,
  isDisabled,
}: CheckboxColumnProps) {
  const row = info;
  const isNew = isNewProduct(row.original);

  if (isNew) {
    return (
      <VStack alignItems="flex-start">
        <span
          style={{
            display: 'inline-block',
            backgroundColor: 'red',
            padding: '0.25rem 0.5rem',
            fontSize: '75%',
            fontWeight: 600,
            lineHeight: 1,
            textAlign: 'center',
            whiteSpace: 'nowrap',
            verticalAlign: 'baseline',
            borderRadius: '0.25rem',
            color: 'white',
          }}
        >
          New
        </span>
      </VStack>
    );
  }

  return (
    <IndeterminateCheckbox
      checked={selectedData.some((selectedRow) => selectedRow.id === row.id)}
      indeterminate={false}
      onChange={row.getToggleSelectedHandler()}
      onClick={() => {
        const isSelected = selectedData.some(
          (selectedRow) => selectedRow.id === row.id
        );
        onSelectOne(row, isSelected);
      }}
      disabled={isDisabled}
    />
  );
}

export function CheckboxHeader({
  table,
  onSelectAll,
  isDisabled,
}: {
  table: any;
  onSelectAll: (values: any[], isChecked: boolean) => void;
  isDisabled: boolean;
}) {
  return (
    <IndeterminateCheckbox
      checked={table.getIsAllRowsSelected()}
      indeterminate={table.getIsSomeRowsSelected()}
      onChange={table.getToggleAllRowsSelectedHandler()}
      onClick={() => {
        onSelectAll(table.getRowModel().rows, table.getIsAllRowsSelected());
      }}
      disabled={isDisabled}
    />
  );
}
